import { Component, Input } from '@angular/core';
import { LossSummary} from '../../../shared';

@Component({
    selector: 'my-loss-summary',
    styles: [require('./loss-summary.component.scss')],
    template: require('./loss-summary.component.pug')
})
export class LossSummaryComponent {
    @Input() lossSummary: LossSummary;

    /*Chart variables */
    private isPieChart: boolean = false;
    private isBarChart: boolean = false;
    private optionNotChart: boolean = false;

    public chartLabels: string[] = ['Inventory Cost', 'Salaries', 'Others'];
    public chartData: Array<number>;

    public barChartData: any[];

    constructor() { }

    showPieChart() {
        this.isPieChart = true;
        this.optionNotChart = true;
        this.isBarChart = false;
        this._UpdateChartInformation();
    }

    private _UpdateChartInformation() {
        this.chartData = [];

        this.chartData.push(this.lossSummary.totalInventory);
        this.chartData.push(this.lossSummary.totalSalaries);
        this.chartData.push(this.lossSummary.totalOthers);
    }

    private _UpdateBarChartInformation() {
        this.barChartData = [];
        let tempObject = {};

        tempObject['data'] = this.chartData;

        this.barChartData.push(tempObject);

    }

    ShowBarChart() {
        this.isPieChart = false;
        this.isBarChart = true;
        this.optionNotChart = true;
        this._UpdateBarChartInformation();
    }

    showInitialSetting() {
        this.isBarChart = false;
        this.optionNotChart = false;
        this.isPieChart = false;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/profit-loss/loss/loss-summary/loss-summary.component.ts